import {FormInputProps} from "@/components/forms/form-input"
import React, {HTMLInputTypeAttribute} from "react"
import {InputType} from "@/components/forms/_form-helpers"
import {parseBool} from "@/library/utilities/general"

const InputElement = (
    type: HTMLInputTypeAttribute,
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => {
    return <input
        key={key}
        type={type}
        name={props.name}
        placeholder={props.placeholder}
        value={currentValue ?? ""}
        tabIndex={props.tabIndex}
        onChange={e => updateValue?.(e.target.value, props)}
        required={!props.optional}
        aria-required={!props.optional}
        title={props.title}
        alt={props.alt}
    />
}

export const InputTextSingleLine = (
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => InputElement('text', props, key, currentValue, updateValue)

export const InputDate = (
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => {
    let type: HTMLInputTypeAttribute

    switch (props.type) {
        default:
        case InputType.DATE:
            type = 'date'
            break
        case InputType.DATE_TIME:
            type = 'datetime'
            break
        case InputType.DATE_TIME_LOCAL:
            type = 'datetime-local'
            break
    }

    return InputElement(type, props, key, currentValue, updateValue)
}

export const InputSelect = (
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => {
    const options = props.options

    if (!options || Object.entries(options).length <= 0)
        return <div key={key} className="alert alert--error">No options provided for input '{props.name}'.</div>

    return <select
        key={key}
        name={props.name}
        value={currentValue ?? ""}
        onChange={e => updateValue?.(e.target.value, props)}
        required={!props.optional}
        aria-required={!props.optional}
        tabIndex={props.tabIndex}
        title={props.title}
    >
        {props.optional && <option></option>}
        {Object.entries(options).map(entry =>
            <option key={`option-${entry[0]}`} value={entry[0]}>{entry[1]}</option>
        )}
    </select>
}

export const InputTextMultiLine = (
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => <textarea
    key={key}
    name={props.name}
    value={currentValue ?? ""}
    placeholder={props.placeholder}
    required={!props.optional}
    aria-required={!props.optional}
    tabIndex={props.tabIndex}
    title={props.title}
    onChange={e => updateValue?.(e.target.value, props)}
    rows={props.rows}
    cols={props.cols}
></textarea>

export const InputCheckbox = (
    props: FormInputProps,
    key?: any,
    currentValue?: string,
    updateValue?: (newValue: any, props: FormInputProps) => void
) => {
    return <input
        key={key}
        type='checkbox'
        name={props.name}
        placeholder={props.placeholder}
        tabIndex={props.tabIndex}
        onChange={e => updateValue?.(e.target.checked, props)}
        required={!props.optional}
        aria-required={!props.optional}
        title={props.title}
        alt={props.alt}
        checked={parseBool(currentValue)}
    />
}
